import { ChangeDetectionStrategy, Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { PkService } from '../pk.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { IPKImportLog, IPKSettings } from '../pk';
import { FiPrintDownloadComponent } from '@fi-shared/fi-print-download/fi-print-download.component';
import { AppTextService } from '@fi-shared/app-text';
import { ProgressType } from '@fi-shared/fi-signal-r/fi-signal-enums';
import { FiSpinnerService } from '@fi-shared/fi-spinner/fi-spinner.service';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Component({
    selector: 'pk-user-import',
    templateUrl: './pk-user-import.component.html',
    styleUrls: ['./pk-user-import.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'pk-user-import' },
    standalone: false,
})
export class PkUserImportComponent implements OnDestroy {
    @Input() pkSettings: IPKSettings;

    importLog: IPKImportLog;

    isTestImportRun$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    isLogShown$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    logCreatedDate: Date;

    constructor(
        private pkService: PkService,
        private appTextService: AppTextService,
        private fiSpinnerService: FiSpinnerService,
        private customerDataService: FiCustomerDataService,
        private userDataService: FiUserDataService,
        private fiFormatDateService: FiFormatDateService,
    ) {}

    testImportUsers() {
        this.importUsersInternal(true);
    }

    importUsers() {
        this.importUsersInternal(false);
    }

    private importUsersInternal(isTestImport: boolean) {
        this.isTestImportRun$.next(isTestImport);
        this.isLogShown$.next(false);

        const promise = isTestImport ? this.pkService.testImportUsers() : this.pkService.importUsers();
        promise.then((result) => {
            this.importLog = result;
            this.isLogShown$.next(true);
            this.logCreatedDate = new Date();
        });

        this.fiSpinnerService.trackPromise(promise, {
            headerText: this.appTextService.get(isTestImport ? 'pk.testing_import' : 'pk.importing_users'),
            signalRProgressType: ProgressType.PKUserImport,
        });
    }

    downloadLogs(fiPrintDownloadComponentRef: FiPrintDownloadComponent) {
        fiPrintDownloadComponentRef.Download();
    }

    getDownloadFileName(): string {
        return `${this.appTextService.get('pk.pk_import_log')} ${this.fiFormatDateService.formatDate(
            this.logCreatedDate,
            'date-time',
            { showToday: false },
        )}`;
    }

    getTime(): string {
        return `${this.fiFormatDateService.formatDate(this.logCreatedDate, 'date-time')}`;
    }

    public uploadUsersJsonForTest($event: Event) {
        const targetFiles = ($event.target as HTMLInputElement).files;
        if (targetFiles && targetFiles.length === 1) {
            this.pkService.uploadUsersJsonForTest(targetFiles[0]);
        }
    }

    isUploadUsersJsonEnabled() {
        //return ["DevRolloutTemp", "Vapiano"].indexOf(this.customerDataService.customerData.CustomerName) === -1; // Vapiano copy
        return this.customerDataService.isTestCustomer();
    }

    getPKApiResponse() {
        this.pkService.getApiResponse();
    }

    isPKApiResponseButtonEnabled() {
        return this.userDataService.canLoginSupportSession();
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
